import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import Sort from '../../components/common/Sort/Sort';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import AddButton from '../../components/common/AddButton/AddButton';
import AddPopup from '../../components/Popup/AddPopup/AddPopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import EditPopup from '../../components/Popup/EditPopup/EditPopup';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import '../../components/common/Table.css';
import '../../pages/Faq/Faqs.css';
import { baseurl } from '../../api';
import { isRequired } from '../../validation';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import { useCheckboxClick } from '../../checkboxclick';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import ToggleSwitch from '../../components/common/ToggleButton/ToggleSwitch';
import { showAlert } from '../../components/common/ExportLabel/Exporterror';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import PermissionFilter from '../../components/common/Filter/PermissionFilter';
import Pagination from '../../components/common/Pagination/pagination';
const pageKey = "user_permissions"


const UserPermissions = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); 
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [selectedGroupArchiveAction, setSelectedGroupArchiveAction] = useState('');
  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const searchCategories = ['Name','Email','Mobile'];
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "All");

  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const [pagination, setPagination] = useState({})
  
  const accessNameChoices = [
    { value: "view", label: "View" },
    { value: "view_all", label: "View All" },
    { value: "add", label: "Add" },
    { value: "edit", label: "Edit" },
    { value: "delete", label: "Delete" },
    { value: "archive", label: "Archive" }
  ];
  

  const fetchPermissions = async (id = null, page = null) => {
    try {
      const url = `${baseurl}accounts/permissions/list/`;
      const config = id
        ? { params: { id } }
        : {
            params: {
              search: searchParams.term,
              sort: mapSortOptionToQuery(selectedSortOption),
              type: selectedFilterOption 
            },
          };
  
      const response = await authenticatedAxios.get(url, config);
  
      if (response?.status === 200) {
        console.log("RESPONSE", response);
        if (id) {
          setSelectedItem(response.data.data);
          setIsEditPopupOpen(true);
        } else {
          setItems(response.data.data);
          setPagination(response.data.pagination);
        }
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else if (process.env.NODE_ENV !== "production") {
        console.error("Error fetching user permissions:", error);
      }
    }
  };
  
    
  
  useEffect(() => {
    fetchPermissions();
    setFilters(pageKey, {
      searchParams,
      selectedSortOption,
    });
  }, [searchParams, selectedSortOption, selectedFilterOption]);



  const AddPermissions = async (formValues) => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}accounts/permissions/`, formValues);
  
      if (response.status === 201) {
        fetchPermissions();
        closePopups();
      }
    } catch (error) {
      const message = error.response?.data?.error || "Something went wrong!";
      showAlert(message);
    }    
  };
  

  const EditPermissions = async (formValues) => {
    console.log(formValues)
    try {
      const response = await authenticatedAxios.put(
        `${baseurl}accounts/permissions/?id=${selectedItem.id}`,
        formValues
      );
  
      if (response.data.response_code === 1) {
        fetchPermissions();
        closePopups();
      }
    } catch (error) {
      const message = error.response?.data?.error || "Something went wrong!";
      showAlert(message);
    }
  };
  
  const handleDelete = async () => {
    try {
      const response = await authenticatedAxios.delete(
        `${baseurl}accounts/permissions/?id=${selectedItem.id}`
      );
  
      if (response.status >= 200 && response.status < 300) {
        setIsDeletePopupOpen(false); 
        fetchPermissions(); 
        return;
      }
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      // console.error('Error deleting plan:', error);
    }
  };
  
  const handleArchiveSelectedItems = async () => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}accounts/permissions/archive/`, {
        id_list: selectedItems,
      });

      if (response.status >= 200 && response.status < 300) {
        fetchPermissions();
        resetCheckboxState();
        closePopups();
      } else {
        console.error('Failed to archive/unarchive selected items.');
      }
    } catch (error) {
      console.error('Error archiving/unarchiving selected items:', error);
    }
  };

  const handleArchive = async () => {
    try {
      const response = await authenticatedAxios.get(
        `${baseurl}accounts/permissions/archive/?id=${selectedItem.id}`
      );
      
      if (response.status >= 200 && response.status < 300) {
        await fetchPermissions();
        closePopups();
        
      } else {
        console.error('Failed to archive.');
      }
    } catch (error) {
      console.error('Error archiving :', error);
    }
  };

  
  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };
const handleFilterSelect = (selectedValue) => {
  setSelectedFilterOption(selectedValue);
};
  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };

  const handleSearchSelect = (searchTerm) => {
    setSearchParams({ term: searchTerm });
  };
  

  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };

  const handleDeleteClick = async (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };
    

  const handleNewClick = () => {
    setSelectedItem(null);
    setIsNewPopupOpen(true);
    // fetchAllData();
  }


  const handleEditClick = (item) => {
    fetchPermissions(item.id)
    // fetchAllData();

   };

  //  useEffect(() =>{
  //   console.log("items",items)
  //  },[items])

    const addPopupFields = [
      { label: 'Feature Name',name:'feature_name', type: 'large-input',validators:[isRequired] },
      { label: 'Access Name ',name:'access_name', type: 'large-select', options:accessNameChoices },
      { label: 'Apply to company',name:'is_company_perm', type: 'toggle',  },

    ];   
    
    const editPopupFields = [
      { label: 'Feature Name',name:'feature_name', type: 'large-input',defaultValue:selectedItem?.feature_name, validators:[isRequired] },
      { label: 'Access Name ',name:'access_name', type: 'large-select',defaultValue:selectedItem?.access_name , options:accessNameChoices },
      { name:'is_company_perm', type: 'toggle', defaultValue:selectedItem?.is_company_perm  },
    ];    
  
    const deletePopupFields = [
      { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
    ];

  const closePopups = () => {
    setIsArchivePopupOpen(false);
    setIsNewPopupOpen(false);
    setIsEditPopupOpen(false)
    setIsDeletePopupOpen(false)
    setSelectedItem([])
  };

  const handleIsCompanyToggle = async (id, value) => {
    try {
      const payload = {
        is_company_perm: value,
      };
  
      const url = `${baseurl}accounts/permissions/?id= ${id} `;
  
      await authenticatedAxios.put(url, payload);
    } catch (error) {
 
      console.error(`Failed to update permission ${id}`);
    }
  };
  
  const handlePageChange = (page) => {
    fetchPermissions(null, page);
  };

  useEffect(() =>{
    console.log(items)
  },[items])

  return (
    <div className='whole-container'>  
      <div className='top-heading'>
        <PageHeader pageName="Settings /" nestedpageName="User Permissions"  linkTo="/internal-users" /> 
        <div className='export-container'>
        <ArchiveSelectedItem
          selectedItems={selectedItems}
          items={items}
          onArchiveSelected={handleArchiveSelectedItems}
        />
            {/* <ExportLabel
              exportUrl={`${baseurl}accounts/internal/users/export/`}
              selectedIds={selectedItems}
              onExportComplete={handleExportComplete}
            /> */}
        </div>
      </div>     
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'> User Permissions</h1>
        </div>
        <div className='pagename-right-container'>
          <AddButton onClick={handleNewClick} />
          {/* <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption}/> */}
          <PermissionFilter
            onFilterSelect={handleFilterSelect}
            defaultValue={selectedFilterOption}
          />

          <SimpleSearchBox categories={searchCategories} onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term}/>
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
        </div>
      </div>
      <div className='permmsions-warning-msg table-container'>
        <svg className="perm-warning-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.67402 13.9453H13.3259C13.4989 13.9453 13.6689 13.9004 13.8194 13.815C13.9698 13.7296 14.0956 13.6066 14.1843 13.458C14.273 13.3095 14.3216 13.1405 14.3255 12.9675C14.3293 12.7946 14.2882 12.6236 14.2062 12.4712L8.88058 2.58062C8.50277 1.87937 7.49714 1.87937 7.11933 2.58062L1.7937 12.4712C1.71169 12.6236 1.6706 12.7946 1.67444 12.9675C1.67829 13.1405 1.72694 13.3095 1.81564 13.458C1.90435 13.6066 2.03007 13.7296 2.18052 13.815C2.33097 13.9004 2.50101 13.9453 2.67402 13.9453Z" stroke="#FF0000" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.82068 6.10587L8.00005 9.91837L8.17912 6.10743C8.18022 6.08307 8.17635 6.05874 8.16773 6.03592C8.15911 6.01311 8.14594 5.99229 8.129 5.97474C8.11207 5.95719 8.09173 5.94328 8.06924 5.93385C8.04674 5.92443 8.02256 5.91969 7.99818 5.91993C7.97422 5.92016 7.95055 5.9252 7.92856 5.93473C7.90658 5.94426 7.88673 5.95811 7.87018 5.97544C7.85364 5.99277 7.84073 6.01324 7.83223 6.03564C7.82373 6.05804 7.8198 6.08192 7.82068 6.10587Z" stroke="#FF0000" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 12.4141C7.87639 12.4141 7.75555 12.3774 7.65277 12.3087C7.54999 12.2401 7.46988 12.1424 7.42258 12.0282C7.37527 11.914 7.36289 11.7884 7.38701 11.6671C7.41113 11.5459 7.47065 11.4345 7.55806 11.3471C7.64547 11.2597 7.75683 11.2002 7.87807 11.1761C7.99931 11.152 8.12497 11.1643 8.23918 11.2116C8.35338 11.2589 8.45099 11.339 8.51967 11.4418C8.58834 11.5446 8.625 11.6654 8.625 11.7891C8.625 11.9548 8.55915 12.1138 8.44194 12.231C8.32473 12.3482 8.16576 12.4141 8 12.4141Z" fill="#FF0000"/>
        </svg>
        <span className='fts-12 ftw-4 '>Warning: This section is intended for developers and technical users only.</span>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />Feature Name
              </th>
              <th>Access Name</th>
              <th>Permission Name</th>
              <th>Apply to Company</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className='common-table-tbody'>
          {items.length > 0 ? (
            items.map((perm) => (
              <tr key={perm.id}  className={perm.is_archived ? 'archived-item' : ''}>
                <td>
                  <input
                    className="table-selectbox table-child-selectbox"
                    type="checkbox"
                    checked={selectedItems.includes(perm.id)}
                    onChange={() => handleChildCheckboxChange(perm.id)}
                  />
                {perm?.feature_name}
                </td>
                <td>{perm.access_name}</td>
                <td>{perm.perm_name}</td>
                <td>
                  <ToggleSwitch 
                    onToggle={(value) => handleIsCompanyToggle(perm.id, value)} 
                    defaultValue={perm?.is_company_perm}
                  />
                </td>
                <td className="actions common-action">
                  <EditIcon onClick={() => handleEditClick(perm)} />
                  <ArchiveIcon onClick={() => handleArchiveClick(perm)} isArchived={perm.is_archived}/>   
                  <DeleteIcon onClick={() => handleDeleteClick(perm)} />          
                </td>  
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">No Permissions found.</td>
            </tr>
          )}            
        </tbody>
        </table>
      </div>
      <Pagination
        currentPage={pagination.current_page}
        totalPages={pagination.total_pages}
        totalCount={pagination.total_items}
        perPage={pagination.items_per_page}
        onPageChange={handlePageChange}
      />
      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived }
        archivename={selectedItem?.perm_name}
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />            
      <AddPopup 
        isOpen={isNewPopupOpen}
        title="New Permission"
        buttonName='Add Permission'
        fields={addPopupFields}
        onSave={AddPermissions}
        onClose={closePopups}
      />
       <EditPopup 
         isOpen={isEditPopupOpen}
         title="Edit Permission"
         fields={editPopupFields}
         onSave={EditPermissions}
         onClose={closePopups}
       /> 
      <DeletePopup
          isOpen={isDeletePopupOpen}
          title="Delete Recipient Group"
          fields={deletePopupFields}
          onSave={handleDelete}
          onClose={closePopups}
      />     
    </div>
  );
};

export default UserPermissions;


